import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonRow,
  IonSpinner,
} from '@ionic/angular/standalone';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DuplicatedValueValidatorDirective } from 'src/app/core/directives/duplicated-value/duplicated-value.directive';
import { AdminRoutingModule } from '../admin/admin.routing.module';
import { ActionButtonComponent } from './form/components/action-button/action-button.component';
import { DatePickerComponent } from './form/components/date-picker/date-picker.component';
import { FormCheckboxComponent } from './form/components/form-checkbox/form-checkbox.component';
import { FormMultiselectDropdownComponent } from './form/components/form-multiselect-dropdown/form-multiselect-dropdown.component';
import { FormSelectComponent } from './form/components/form-select/form-select.component';
import { FormTextFieldComponent } from './form/components/form-text-field/form-text-field.component';
import { FormTimePickerComponent } from './form/components/form-time-picker/form-time-picker.component';
import { NoResultsFoundComponent } from './form/components/no-results-found/no-results-found.component';
import { ReadOnlyFieldsComponent } from './form/components/read-only-fields/read-only-fields.component';
import { ColumnFormComponent } from './form/two-column-form/column-form/column-form.component';
import { TwoColumnFormComponent } from './form/two-column-form/two-column-form.component';
import { LoadingModalComponent } from './modal/components/loading-modal/loading-modal.component';
import { ModalErrorBannerComponent } from './modal/components/modal-frame/modal-error-banner/modal-error-banner.component';
import { ModalFrameComponent } from './modal/components/modal-frame/modal-frame.component';
import { ExitModalComponent } from './modal/exit-modal/exit-modal.component';
import { ProfileModalComponent } from './modal/profile-modal/profile-modal.component';
import { PdfReportGeneratorComponent } from './pdf-report/pdf-report-generator/pdf-report-generator.component';
import { FilterByCodePipe } from './pipes/filter-by-code.pipe';
import { TableActionCellComponent } from './table/components/table-action-cell/table-action-cell.component';
import { AddRouteComponent } from './table/components/table-add-route/add-route/add-route.component';
import { TableAddRouteComponent } from './table/components/table-add-route/table-add-route.component';
import { TableDropdownStatusComponent } from './table/components/table-dropdown-status/table-dropdown-status.component';
import { TableHeaderDropdownComponent } from './table/components/table-header-dropdown/table-header-dropdown.component';
import { ExcelIconComponent } from './table/components/table-header/excel-icon/excel-icon.component';
import { FilterIconComponent } from './table/components/table-header/filter-icon/filter-icon.component';
import { HeaderSearchComponent } from './table/components/table-header/header-search/header-search.component';
import { NewItemIconComponent } from './table/components/table-header/new-item-icon/new-item-icon.component';
import { RadioButtonComponent } from './table/components/table-header/radio-button/radio-button.component';
import { TableHeaderComponent } from './table/components/table-header/table-header.component';
import { TablePaginationComponent } from './table/components/table-pagination/table-pagination.component';
import { TableSearchComponent } from './table/components/table-search-component/table-search.component';
import { TableSortingBoxComponent } from './table/components/table-sorting-box/table-sorting-box.component';
import { TableTimePickerComponent } from './table/components/table-time-picker/table-time-picker.component';
import { LocationAdminTableComponent } from './table/location-admin-table/location-admin-table.component';
import { UserAdminTableComponent } from './table/user-admin-table/user-admin-table.component';
import { TabComponent } from './tabs/tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';

@NgModule({
  declarations: [
    FilterIconComponent,
    TableHeaderComponent,
    TabsComponent,
    TabComponent,
    TableSearchComponent,
    TableSortingBoxComponent,
    LocationAdminTableComponent,
    UserAdminTableComponent,
    FormCheckboxComponent,
    FormSelectComponent,
    FormTextFieldComponent,
    ModalFrameComponent,
    DuplicatedValueValidatorDirective,
    TwoColumnFormComponent,
    ColumnFormComponent,
    FormMultiselectDropdownComponent,
    TableDropdownStatusComponent,
    ActionButtonComponent,
    DatePickerComponent,
    TableTimePickerComponent,
    TableHeaderDropdownComponent,
    ExcelIconComponent,
    NewItemIconComponent,
    RadioButtonComponent,
    TableActionCellComponent,
    FormTimePickerComponent,
    LoadingModalComponent,
    ProfileModalComponent,
    ReadOnlyFieldsComponent,
    PdfReportGeneratorComponent,
    NoResultsFoundComponent,
    ExitModalComponent,
    TablePaginationComponent,
    ModalErrorBannerComponent,
    AddRouteComponent,
    TableAddRouteComponent,
  ],
  imports: [
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatSortModule,
    MatCheckboxModule,
    AdminRoutingModule,
    MatIconModule,
    CommonModule,
    MatTableModule,
    NgSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    NgxMaterialTimepickerModule,
    HeaderSearchComponent,
    IonItem,
    IonCheckbox,
    IonLabel,
    IonItemGroup,
    IonInput,
    IonCard,
    IonCardTitle,
    IonCardContent,
    IonCol,
    IonSpinner,
    IonGrid,
    IonIcon,
    IonRow,
    IonButtons,
    FilterByCodePipe,
  ],
  exports: [
    CommonModule,
    FilterIconComponent,
    TableHeaderComponent,
    TabsComponent,
    TabComponent,
    TableSearchComponent,
    TableSortingBoxComponent,
    LocationAdminTableComponent,
    UserAdminTableComponent,
    FormCheckboxComponent,
    FormSelectComponent,
    ModalFrameComponent,
    FormTextFieldComponent,
    DuplicatedValueValidatorDirective,
    TwoColumnFormComponent,
    FormMultiselectDropdownComponent,
    ActionButtonComponent,
    DatePickerComponent,
    TableTimePickerComponent,
    TableHeaderDropdownComponent,
    ExcelIconComponent,
    TableDropdownStatusComponent,
    TableActionCellComponent,
    RadioButtonComponent,
    FormTimePickerComponent,
    LoadingModalComponent,
    ReadOnlyFieldsComponent,
    PdfReportGeneratorComponent,
    NoResultsFoundComponent,
    ExitModalComponent,
    TablePaginationComponent,
    TableAddRouteComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
